<div class="admin-users">
  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h4 class="m-0">Users<span *ngIf="totalCount" class="text-muted fs-6"> ({{ totalCount }})</span></h4>
    <div class="d-flex align-items-center gap-2">
      <input
        type="text"
        class="form-control"
        style="max-width: 280px"
        placeholder="Search email, first or last name"
        (input)="onSearch($any($event.target).value)"
      />
      <button class="btn btn-outline-primary" (click)="loadUsers()" [disabled]="loading">
        Refresh
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-4 text-muted">Loading users…</div>

  <div *ngIf="!loading && errored" class="alert alert-warning">
    Unable to load users. Please try again.
  </div>

  <div *ngIf="!loading && !errored && users.length === 0" class="text-center py-4 text-muted">
    No users found.
  </div>

  <div class="table-responsive" *ngIf="!loading && !errored && users.length > 0">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th [class.sortable]="isSortable('email')" (click)="setSort('email')">
            Email{{ sortIndicator('email') }}
          </th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Type</th>
          <th [class.sortable]="isSortable('createdDate')" (click)="setSort('createdDate')">
            Created{{ sortIndicator('createdDate') }}
          </th>
          <th [class.sortable]="isSortable('lastLogin')" (click)="setSort('lastLogin')">
            Last Login{{ sortIndicator('lastLogin') }}
          </th>
          <th class="text-center">Locked</th>
          <th class="text-end">Searches</th>
          <th class="text-end">Notify</th>
          <th class="text-end">Favourites</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let u of users" class="user-row" (click)="openDetail(u)">
          <td>{{ u.email }}</td>
          <td>{{ u.firstName }}</td>
          <td>{{ u.lastName }}</td>
          <td>{{ u.userType }}</td>
          <td>{{ u.createdDate | date : 'dd/MM/yyyy' }}</td>
          <td>{{ u.lastLogin ? (u.lastLogin | date : 'dd/MM/yyyy HH:mm') : 'Never' }}</td>
          <td class="text-center">
            <span *ngIf="u.accountLocked" class="badge bg-danger">Locked</span>
          </td>
          <td class="text-end">{{ u.savedSearchCount || 0 }}</td>
          <td class="text-end">{{ u.notifyCount || 0 }}</td>
          <td class="text-end">{{ u.favouriteCount || 0 }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- pagination -->
  <div
    class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-2"
    *ngIf="!loading && !errored && totalCount > 0"
  >
    <div class="d-flex align-items-center gap-2">
      <span class="text-muted small">Rows per page</span>
      <select
        class="form-select form-select-sm"
        style="width: auto"
        [value]="query.pageSize"
        (change)="changePageSize($any($event.target).value)"
      >
        <option *ngFor="let s of pageSizeOptions" [value]="s">{{ s }}</option>
      </select>
    </div>
    <div class="d-flex align-items-center gap-2">
      <span class="text-muted small">Page {{ query.page }} of {{ totalPages || 1 }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="prevPage()" [disabled]="query.page <= 1">
        Prev
      </button>
      <button class="btn btn-sm btn-outline-secondary" (click)="nextPage()" [disabled]="query.page >= totalPages">
        Next
      </button>
    </div>
  </div>
</div>

<!-- read-only detail drawer -->
<div class="users-drawer-backdrop" *ngIf="drawerOpen" (click)="closeDetail()"></div>
<div class="users-drawer" [class.open]="drawerOpen">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="m-0">User Detail</h5>
    <button class="btn-close" (click)="closeDetail()" aria-label="Close"></button>
  </div>

  <div *ngIf="detailLoading" class="text-muted py-3">Loading…</div>
  <div *ngIf="!detailLoading && detailErrored" class="alert alert-warning">
    Unable to load user detail.
  </div>

  <div *ngIf="!detailLoading && selectedDetail">
    <section class="mb-4">
      <h6 class="text-uppercase text-muted small">Summary</h6>
      <p class="mb-1"><strong>Email:</strong> {{ selectedDetail.summary.email }}</p>
      <p class="mb-1">
        <strong>Name:</strong> {{ selectedDetail.summary.firstName }}
        {{ selectedDetail.summary.lastName }}
      </p>
      <p class="mb-1"><strong>Type:</strong> {{ selectedDetail.summary.userType }}</p>
      <p class="mb-1">
        <strong>Created:</strong>
        {{ selectedDetail.summary.createdDate | date : 'dd/MM/yyyy' }}
      </p>
      <p class="mb-1">
        <strong>Last Login:</strong>
        {{
          selectedDetail.summary.lastLogin
            ? (selectedDetail.summary.lastLogin | date : 'dd/MM/yyyy HH:mm')
            : 'Never'
        }}
      </p>
      <p class="mb-1">
        <strong>Account Locked:</strong>
        {{ selectedDetail.summary.accountLocked ? 'Yes' : 'No' }}
      </p>
    </section>

    <section class="mb-4">
      <h6 class="text-uppercase text-muted small">
        Saved Searches ({{ selectedDetail.savedSearches.length }})
      </h6>
      <p *ngIf="selectedDetail.savedSearches.length === 0" class="text-muted small">None</p>
      <div *ngFor="let s of selectedDetail.savedSearches" class="drawer-item">
        <div><strong>{{ s.term }}</strong></div>
        <div class="text-muted small">
          Status: {{ s.status || '-' }} | Style: {{ s.registrationStyle || '-' }} |
          Budget: {{ s.budget || '-' }} | Sale: {{ s.saleType || '-' }}
        </div>
        <div class="text-muted small">Added: {{ s.dateAdded | date : 'dd/MM/yyyy' }}</div>
      </div>
    </section>

    <section class="mb-4">
      <h6 class="text-uppercase text-muted small">
        Notify-Me Watches ({{ selectedDetail.notifyWatches.length }})
      </h6>
      <p *ngIf="selectedDetail.notifyWatches.length === 0" class="text-muted small">None</p>
      <div *ngFor="let n of selectedDetail.notifyWatches" class="drawer-item">
        <strong>{{ n.registration }}</strong>
        <span class="text-muted small"> — {{ n.dateAdded | date : 'dd/MM/yyyy' }}</span>
      </div>
    </section>

    <section class="mb-2">
      <h6 class="text-uppercase text-muted small">
        Favourites ({{ selectedDetail.favourites.length }})
      </h6>
      <p *ngIf="selectedDetail.favourites.length === 0" class="text-muted small">None</p>
      <div *ngFor="let f of selectedDetail.favourites" class="drawer-item">
        <strong>{{ f.registration }}</strong>
        <span class="text-muted small" *ngIf="f.term"> — {{ f.term }}</span>
      </div>
    </section>
  </div>
</div>
